import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../../services/api';
import { purge } from '@vy/utils';
import type { CustomUseQueryOptions } from '../../requests-types/custom-use-query-options';
import { useMorningEnabled } from './use-morning-enabled';
import { MorningGetCustomersResponse } from '@vy/api-definition';
import { queryKeys } from '../../../../services/query-key/query-keys';

export function useMorningCustomers(
  searchParam?: string,
  options?: CustomUseQueryOptions<MorningGetCustomersResponse>,
) {
  const isMorningConnected = useMorningEnabled();

  const queryDeps = purge([searchParam]);

  return useQuery(
    queryKeys.morningCustomers(...queryDeps),
    async () => {
      const api = getPrivateApi();
      const response = await api.morningGetCustomers({ search: searchParam });

      return response;
    },
    {
      ...options,
      enabled: isMorningConnected,
    },
  );
}